<script>
    import { onMount } from 'svelte';
    import Checkbox from "./Checkbox.svelte";
    import FormColumn from './FormColumn.svelte';
    import FormRow from './FormRow.svelte';

    export let prefix = "chkDelimiter_";
    export let delimiter = ";"
    export let delimitedString = "";
    export let optionsList;
    export let optionsListLabel = "label";
    export let orientation = "vertical";
    export let disabled = false;
    
    let delimitedStringValues = [];

    // Function to update the delimited string when checkbox state changes
    function updateDelimitedString() {
        delimitedString = delimitedStringValues.join(delimiter);
    }

    onMount(() => {
        // Split the delimited string using the delimiter character
        if (delimitedString != null) {
            delimitedStringValues = [...delimitedString.split(delimiter)];
        }        
    });

    function handleCheckboxChange(item) {
        if (delimitedStringValues.includes(item.value)) {
            delimitedStringValues = delimitedStringValues.filter(value => value !== item.value);
            updateDelimitedString();
        } else {
            delimitedStringValues.push(item.value);
            updateDelimitedString();
        }
    }

    $: {
        if (delimitedString != null) {
            delimitedStringValues = delimitedString.split(delimiter);
        }        
    }
</script>

<div>
    {#if optionsList && optionsList.length}        
        {#if orientation == "vertical"}
        {#each optionsList as item, i}
        <FormRow>
            <FormColumn>
                <Checkbox 
                    checked="{delimitedStringValues.includes(item.value)}" 
                    label="{item[optionsListLabel]}" 
                    id="{prefix}{i}" 
                    change={() => handleCheckboxChange(item)}
                    {disabled}
                ></Checkbox>
            </FormColumn>
        </FormRow>    
        {/each}
        {:else}
        <FormRow>            
            <FormColumn>
                {#each optionsList as item, i}
                <Checkbox 
                    checked="{delimitedStringValues.includes(item.value)}" 
                    label="{item[optionsListLabel]}" 
                    id="{prefix}{i}" 
                    change={() => handleCheckboxChange(item)}
                    {disabled}
                ></Checkbox>
                <div class="spacer"></div>
                {/each}
            </FormColumn>            
        </FormRow> 
        {/if}        
    {/if}
</div>

<style>
    .spacer {
        margin-left: 40px;
        display: inline;
    }
</style>